// Gjenbrukbare render-helpers — rene funksjoner som returnerer HTML-strenger.
// Bruker felles design-tokens (--fs-*, --fw-*, --rad-*) via CSS-klasser i
// components.css, slik at inline-stiler ikke lenger spriker på tvers av
// visninger. Ny felles kilde for små UI-byggeklosser (chips, etiketter …).
import { esc } from './utils.js';

// Fargekodet «chip»/etikett. color = hex, f.eks. "#38bdf8".
// Fargen settes inline (dynamisk), resten kommer fra .ui-chip-klassen.
export function chip(label, color){
  return `<span class="ui-chip" style="background:${color}1f;color:${color};border:1px solid ${color}40">${esc(label)}</span>`;
}
